import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankErrorPage} from 'features/saved-accounts/pages/ConnectBankErrorPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/connect-bank/error',
)({
  component: ConnectBankErrorPage,
});
